<div class="gift-cards-banner-container">
  <div class="cards-banner-content">
    <div class="fw-bold card-banner-title"
         [translate]="'giftCards.banners.receipt.title'">
      Looking for gift tips? Give a gift card for cakes!
    </div>

    <div class="mt-2 font-md"
         [translate]="'giftCards.banners.receipt.description'">
      Best gift in Norway? A gift card that can be used to buy cakes from over 400 bakeries all over the country.
    </div>

    <button class="mt-3 btn btn-primary fw-normal cards-read-more-btn"
            [translate]="'giftCards.banners.receipt.readMore'"
            (click)="onReadMore.emit()">
      Les om vårt gavekort
    </button>
  </div>

  <div class="glad-gavecord-wrap ms-4 d-none d-md-block">
    <img src="/assets/img/content/glad-gavekort.jpeg" [alt]="'giftCards.banners.receipt.title' | translate">
  </div>
</div>
